import React from 'react';

import { Typography, Button } from '@material-ui/core';
import EndIcon from '@material-ui/icons/Lens';

import FeedItem from './FeedItem';

import classes from '../../../css/getCSS';


const feedList = (props) => {
  let display = null;

  if (props.count > 0) {
    display = props.feed.map((item) => {
      return (
        <React.Fragment key={item.id}>
          <FeedItem item={item} />
        </React.Fragment>
      );
    });
  } else {
    display = (
      <div align="center">
        <Typography variant="subheading">No activities found!</Typography>
      </div>
    );
  }

  let feedEnd = null;
  if (!props.next && props.count > 0) {
    feedEnd = (
      <div align="center">
        <EndIcon className={classes.endIcon} />
      </div>
    );
  }

  let nextLoader = null;
  if (props.next) {
    nextLoader = (
      <div align="center">
        <Button variant="contained" color="primary" onClick={() => props.loadMore(props.next)}>Load More</Button>
      </div>
    );
  }

  return (
    <React.Fragment>
      {display}
      {nextLoader}
      {feedEnd}
    </React.Fragment>
  );
};

export default feedList;



// WEBPACK FOOTER //
// ./src/dashboard/components/feed/FeedList.js